import React from 'react';

interface Props {
  lines?: number;
  children?: string;
  className?: string;
}

export const LineClamper: React.FC<Props> = ({ children = '', className, lines = 3 }) => {
  return (
    <div
      style={{
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: lines,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        lineHeight: 1.2,
      }}
      className={className}
    >
      {children}
    </div>
  );
};
